var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlignCenter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 9,
  y: 1,
  width: 3,
  height: 19
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.41678008,6.53810042 L3.29753109,4.41885143 C2.90586282,4.02718316 2.90136108,3.39666518 3.29472191,3.00330434 L4.00330434,2.29472191 C4.39342114,1.90460511 5.01930217,1.89798183 5.41885143,2.29753109 L8.24446938,5.12314904 L8.95305181,5.83173147 C9.34316861,6.22184827 9.3497919,6.8477293 8.95024264,7.24727855 L5.41885143,10.7786698 C5.02718316,11.170338 4.39666518,11.1748398 4.00330434,10.7814789 L3.29472191,10.0728965 C2.90460511,9.6827797 2.89798183,9.05689868 3.29753109,8.65734942 L5.41678008,6.53810042 Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6213203,14.5 L17.7405693,16.619249 C18.1322376,17.0109173 18.1367393,17.6414352 17.7433785,18.0347961 L17.0347961,18.7433785 C16.6446793,19.1334953 16.0187983,19.1401186 15.619249,18.7405693 L12.793631,15.9149514 L12.0850486,15.206369 C11.6949318,14.8162522 11.6883085,14.1903711 12.0878578,13.7908219 L15.619249,10.2594307 C16.0109173,9.8677624 16.6414352,9.86326065 17.0347961,10.2566215 L17.7433785,10.9652039 C18.1334953,11.3553207 18.1401186,11.9812017 17.7405693,12.380751 L15.6213203,14.5 Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 14,
  y: 13,
  width: 7,
  height: 3,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 0,
  y: 5,
  width: 7,
  height: 3,
  rx: 0.5
}))));
export default SvgAlignCenter;